<template>
  <div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col>
          <div class="card card-custom gutter-b">
            <div v-for="(textField, i) in textFields" :key="i" class="text-fields-row d-flex mb-3 mt-5 flex-wrap">

              <div class="col-md-7">
                <span v-if="i + 1 == 1">{{ i + 1 }}# first why</span>
                <span v-if="i + 1 == 2">{{ i + 1 }}# second why</span>
                <span v-if="i + 1 == 3">{{ i + 1 }}# third why</span>
                <span v-if="i + 1 == 4">{{ i + 1 }}# forth why</span>
                <span v-if="i + 1 == 5">{{ i + 1 }}# fifth why</span>
                <div class="text-fields-row">
                  <div class="col-12 mb-2 d-flex flex-wrap">
                    <label class="col-md-4">
                      Why?
                    </label>
                    <div class="col-md-8">
                      <b-form-textarea label="Why?" v-model="textField.why" placeholder="Tell more on what happened...">
                      </b-form-textarea>
                    </div>
                  </div>
                  <div class="col-12 mb-2 d-flex flex-wrap">
                    <label class="col-md-4">
                      Reason :
                    </label>
                    <div class="col-md-8">
                      <b-form-textarea label="Reason" v-model="textField.solution"
                        placeholder="How did you solve the issue..." class="mb-2"></b-form-textarea>
                      <b-form-file v-model="file" :state="file" @change="(e) => previewFiles(e, i)"
                        :placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')" :drop-placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')"
                        accept="image/png,image/jpeg,image/jpg"></b-form-file>
                      <span class="mt-3 text-danger" v-if="textField.isImageSize == true"> File size exceeds 9 MB
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-fields-row d-flex mb-3 mt-5 flex-wrap">
                <div class="col-md-5">
                  <span v-if="textField.tempImgPath" class="symbol-label w-100 d-block">
                    <b-img class="h-50 align-self-center" fluid v-b-modal.modal-1 v-bind:src="textField.tempImgPath"
                      alt="Image 1"></b-img>
                  </span>
                  <span v-else-if="textField.filePath != ''" class="symbol-label w-100 d-block">
                    <b-img class="h-50 align-self-center" fluid v-b-modal.modal-1
                      v-bind:src="'media/' + textField.filePath" alt="Image 1"></b-img>
                  </span>
                  <span>{{textField.tempImgPath}}</span>
                  <span>{{textField.size}}</span>
                </div>
              </div>
            </div>
            <div v-if="IsShow" class="text-fields-row d-flex flex-wrap">
              <div class="col-4 mb-4">
                <b-btn @click="printWindow" class="primary mr-2">Print</b-btn>
              </div>
              <div class="col-8 mb-8 d-flex flex-row-reverse">
                <b-button v-if="isImageSize" disabled @click="submitData" type="button" variant="primary">Submit
                </b-button>
                <b-button v-else @click="submitData" type="button" variant="primary">Submit</b-button>
                <b-btn v-if="IsEnable" @click="add" class="primary mr-2">add</b-btn>
                <b-btn v-else disabled class="primary ml-2">add</b-btn>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

const dataURItoBlob = (dataURI) => {
  const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
    ? atob(dataURI.split(',')[1])
    : unescape(dataURI.split(',')[1]);
  const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const max = bytes.length;
  const ia = new Uint8Array(max);
  for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
  return new Blob([ia], { type: mime });
};

const resizeImage = ({ file, maxSize }) => {
  const reader = new FileReader();
  const image = new Image();
  const canvas = document.createElement('canvas');
 
  const resize = () => {
    let { width, height } = image;

    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);

    const dataUrl = canvas.toDataURL('image/jpeg');
    return dataURItoBlob(dataUrl);
  };

  return new Promise((ok, no) => {
    if (!file.type.match(/image.*/)) {
      no(new Error('Not an image'));
      return;
    }

    reader.onload = (readerEvent) => {
      image.onload = () => ok(resize());
      image.src = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export default {
  props: {
    breadcrumbs: Array,
  },
  components: {
  },
  data() {
    return {
      conveyorId: this.$route.params.conveyorId,
      lineId: this.$route.params.id,
      HistoryId: this.$route.params.Id,
      conveyorIds: [],
      isImageSize: false,
      file: null,
      form: {
        email: "",
        name: "",
        food: null,
        checked: [],
      },
      show: true,
      textFields: [],
      IsEnable: true,
      IsShow:true,
    };
  },
  async mounted() {


    await axios
      .get('line/getmaintanacedata/' + this.HistoryId)
      .then((response) => {
        const HistoryMaintanaceData = response.data;
        if (HistoryMaintanaceData == '') {
          this.textFields.push({
            why: "",
            solution: "",
            file: null,
            fileName: "",
            filePath: "",
            historyId: "",
            isImageSize: false,
            id: ""
          });
        } else {
          HistoryMaintanaceData.map((Maintanace) => {
            this.textFields.push({
              why: Maintanace.why,
              solution: Maintanace.solution,
              file: null,
              fileName: "",
              filePath: Maintanace.imagePath,
              historyId: Maintanace.historyId,
              isImageSize: false,
              id: Maintanace.id
            });

          })
        }


      })
      .catch((err) => {
        throw err;
      });

    this.$store.dispatch(SET_BREADCRUMB, [{
      title: `Home > Line ${this.lineId} > Conveyor ${this.conveyorId} > Maintennance ${this.HistoryId}`,
      route: `/line/${this.lineId}/conveyor/${this.conveyorId}`
    }]);

    await this.getConveyors();
  },
  methods: {
    submitData() {
      let formData = new FormData();

      for (var i = 0; i < this.textFields.length; i++) {
        formData.append('imagesArray', this.textFields[i].file)
      }

      formData.append("FormAllData", JSON.stringify(this.textFields));
      formData.append("conveyorId", this.conveyorId);
      formData.append("lineId", this.lineId);
      formData.append("HistoryId", this.HistoryId);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      axios.post('line/addMaintanaceData/' + this.HistoryId, formData, config)
        .then(async () => {
          this.textFields = []
          await axios
            .get('line/getmaintanacedata/' + this.HistoryId)
            .then((response) => {
              const HistoryMaintanaceData = response.data;
              if (HistoryMaintanaceData == '') {
                this.textFields.push({
                  why: "",
                  solution: "",
                  file: null,
                  fileName: "",
                  filePath: "",
                  historyId: "",
                  isImageSize: false,
                  id: ""
                });
              } else {
                HistoryMaintanaceData.map((Maintanace) => {
                  this.textFields.push({
                    why: Maintanace.why,
                    solution: Maintanace.solution,
                    file: null,
                    fileName: "",
                    filePath: Maintanace.imagePath,
                    historyId: Maintanace.historyId,
                    id: Maintanace.id,
                    isImageSize: false
                  });

                })
              }


            })
            .catch((err) => {
              throw err;
            });
        }).catch(err => {
          throw err;
        })
    },
     printWindow: function () {	
       this.IsShow = false	
       setTimeout(()=>{
   	 window.print();
      this.IsShow = true
 },1000);
       

    },

    add() {
      if (this.textFields.length + 1 == 5) {
        this.IsEnable = false
      } else {
        this.IsEnable = true

      }
      this.textFields.push({
        why: "",
        solution: "",
        file: null,
        fileName: "",
        filePath: "",
        historyId: "",
        isImageSize: false,
        id: "",
      });
    },
    remove(index) {
      this.textFields.splice(index, 1)
    },
    async getConveyors() {
      await axios
        .get("line/" + this.lineId)
        .then((response) => {
          const conveyors = response.data;
          for (let conveyor in conveyors) {
            this.conveyorIds.push(conveyors[conveyor].conveyorNumber);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    async previewFiles(event, i) {

      if (event.target.files[0].size >= '9942880') {
        this.isImageSize = true
        this.textFields[i]['isImageSize'] = true
      } else {
        this.isImageSize = false
        this.textFields[i]['isImageSize'] = false
      }
      this.textFields[i]['file'] = event.target.files[0];
      this.textFields[i]['fileName'] = event.target.files[0].name;
      this.textFields[i]['tempImgPath'] = URL.createObjectURL(event.target.files[0]);

        const FileName = event.target.files[0].name.toString().replaceAll(' ', '-').split('.').join('-').toLowerCase().substr(0, event.target.files[0].name.lastIndexOf('.'));
        // const FileName = event.target.files[0].name;
        const photoUrl = URL.createObjectURL(event.target.files[0]);
        const image = new Image();
        const imageDimensions = await new Promise((resolve) => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            };
            resolve(dimensions);
          };
          image.src = photoUrl;
        });
        var extension = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('.') + 1);
        if(extension == 'jpeg' || extension == 'png'){
          extension = 'jpg'
        }
        if (imageDimensions.width > 1000) {
          const ResizedImage = await new Promise((resolve) => {
            resizeImage({ file: event.target.files[0], maxSize: 1000 }).then((resizedImage) => {
              this.textFields[i]['tempImgPath'] = URL.createObjectURL(resizedImage);
              const cfile = new File([resizedImage], FileName + "."+extension,
                { type: resizedImage.type, lastModified: Date.now() });
              resolve(cfile);
              return cfile;
            }).catch((err) => {
              throw err;
            });
            });

          this.textFields[i]['file'] = ResizedImage;
        } else {
          this.textFields[i]['file'] = event.target.files[0];
        }

    }
  },
};
</script>
